const questions = [
  {
    id: 1,
    title: 'Які у вас години роботи?',
    info: 'Наш ресторан працює з понеділка по суботу з 11:00 до 22:00 та в неділю з 12:00 до 21:00. Ми запрошуємо вас завітати до нас у ці години.',
  },
  {
    id: 2,
    title: 'Ви приймаєте замовлення?',
    info: 'Так, ми приймаємо замовлення як по телефону, так і через наш сайт. Будь ласка, звяжіться з нами заздалегідь, щоб зробити бронювання.',
  },
  {
    id: 3,
    title: 'Які форми оплати ви приймаєте?',
    info: 'Ми приймаємо платежі готівкою, кредитними та дебетовими картками. Ми не приймаємо оплату чеками.',
  },
  {
    id: 4,
    title: 'Ви організовуєте вечірки чи корпоративні заходи?',
    info: 'Так, ми організовуємо фуршети та корпоративні заходи. Ми надаємо спеціальне меню та сервіровку столів відповідно до потреб наших клієнтів.',
  },
  {
    id: 5,
    title: 'Чи є у вас місця для паркування для клієнтів?',
    info: 'Так, у нас є приватна автостоянка для наших клієнтів. Ми також пропонуємо паркувальні місця біля нашого ресторану.',
  },
];

export default questions;
